import { create } from "zustand";

type Tema = "claro" | "escuro";

function inicial(): Tema {
  try {
    const salvo = localStorage.getItem("zh-tema");
    if (salvo === "claro" || salvo === "escuro") return salvo;
  } catch {
    /* localStorage indisponível (modo privado): usa preferência do sistema */
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "escuro" : "claro";
}

export const useTema = create<{ tema: Tema; alternar: () => void }>((set, get) => ({
  tema: typeof window === "undefined" ? "claro" : inicial(),
  alternar: () => {
    const proximo: Tema = get().tema === "escuro" ? "claro" : "escuro";
    document.documentElement.classList.toggle("dark", proximo === "escuro");
    try {
      localStorage.setItem("zh-tema", proximo);
    } catch {
      /* ignora */
    }
    set({ tema: proximo });
  },
}));
